import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import {IPopulatedCutter, IPopulatedJob} from "../../../types/FrontendTypes.ts";
import {DialogContent, IconButton} from "@mui/material";
import ImageRest from '../../../rest/ImageRest.ts';
import {Check, Close, Launch} from "@mui/icons-material";
import {CardGrid, StandardCard} from '@laser-project/kyui';
import {getCutterStatusChips} from "../../../components/StatusChips/CutterStatusChips.tsx";
import Boxel from "../../../components/Icons/Boxel.tsx";

export interface CutterSelectionDialogProps {
    open: boolean;
    selectedCutter: string;
    handleClose: (value: string) => void;
    job: IPopulatedJob;
    cutters: IPopulatedCutter[];
    imageRest: ImageRest;
}

export function CutterDialog(props: CutterSelectionDialogProps) {
    const {handleClose, selectedCutter, open, job, cutters, imageRest} = props;

    const onClose = () => {
        handleClose(selectedCutter);
    };

    const handleCutterSelection = (value: string) => {
        handleClose(value);
    };


    const cutterCards = cutters.map((cutter) => (
        <StandardCard
            key={cutter._id}
            title={cutter.name}
            overlayIcon={job?.cutterId == cutter._id ? <Check/> : undefined}
            onClick={() => handleCutterSelection(cutter._id)}
            image={cutter.imageId ? imageRest.getUrlById(cutter.imageId) : undefined}
            imageAlt={cutter.name || "Cutter image"}
            fallbackIcon={<Boxel/>}
            type="model"
            chips={getCutterStatusChips(cutter)}
            menuActions={[
                {
                    icon: <Launch/>,
                    label: "Open cutter page",
                    onClick: () => window.open(`/cutter/${cutter._id}`, '_blank')
                }
            ]}
        />
    ));

    return (
        <Dialog onClose={onClose} open={open} maxWidth="md" fullWidth={true}>
            <DialogTitle>Select cutter</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 12,
                    color: theme.palette.grey[500],
                })}
            >
                <Close/>
            </IconButton>
            <DialogContent dividers sx={{p: 2}}>
                <CardGrid
                    cards={cutterCards}
                />
            </DialogContent>
        </Dialog>
    );
}